import React, { useState, memo } from 'react'
import clsx from 'clsx'
import { useAppEx, useTbViewStore } from '@vt/hooks'
import { useRouteTo } from '@vt/comps'
import { pick } from 'lodash-es'

const Tabs = function ({ tabs = [] }) {
  const { appId } = useAppEx()
  const { routeTo } = useRouteTo({ appId })
  // 默认选中
  const activeTab = tabs.find((v) => v.active)

  const [currentTab, setCurrentTab] = useState(
    activeTab || (tabs.length && tabs[0])
  )
  const { setFilters } = useTbViewStore((state) => pick(state, ['setFilters']))

  return (
    <div
      className="flex items-center gap-2 text-color-100"
      style={{
        fontSize: '0.875rem',
        borderBottom: '1px solid #e7e7e7',
        height: '48px',
      }}
    >
      {tabs.map((item) => {
        return (
          <div
            className={clsx(
              [
                {
                  'font-semibold text-primary-700':
                    currentTab.title === item.title,
                  'border-b-transparent': currentTab.title !== item.title,
                },
              ],
              'border-b-2 flex items-center justify-center cursor-pointer h-full p-4'
            )}
            style={{
              borderBottomColor:
                currentTab.title === item.title &&
                'var(--ow-color-primary-700)',
            }}
            key={item.title}
            onClick={() => {
              if (item.actionType === 'open' && item.url) {
                routeTo(item.url)
              } else if (item.actionType === 'filter') {
                setCurrentTab(item)
                setFilters(item.filters)
              }
            }}
          >
            {item.title}
          </div>
        )
      })}
    </div>
  )
}

export default memo(Tabs)
